import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var _ = function _(t) {
    return t;
  },
  _t;
import { ALIGNMENT } from "../../constants/alignment";
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import Markdown from "../markdown";
import { Headline, Text } from "../typography";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1l25gc8-0"
})(["text-align:", ";"], function (_ref) {
  var alignment = _ref.alignment;
  return alignment === ALIGNMENT.LEADING ? 'start' : 'center';
});
export var Title = styled(Headline).withConfig({
  componentId: "sc-1l25gc8-1"
})(["margin:0;"]);
export var Description = styled(Text).withConfig({
  componentId: "sc-1l25gc8-2"
})(["margin:16px 0 0;", ";"], mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 24px 0 0;\n  "]))))));
export var StyledMarkdown = styled(Markdown).withConfig({
  componentId: "sc-1l25gc8-3"
})(["color:", ";a{text-decoration:underline;}"], function (_ref2) {
  var color = _ref2.color;
  return color ? color : 'inherit';
});